import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Layout } from "./components/Layout";
import { AccountPage } from "./pages/AccountPage";
import { CreatePage } from "./pages/CreatePage";
import { HomePage } from "./pages/HomePage";
import { LegalPage } from "./pages/LegalPage";
import { LibraryPage } from "./pages/LibraryPage";
import { PricingPage } from "./pages/PricingPage";
import { OrdersPage } from "./pages/OrdersPage";
import { ResultPage } from "./pages/ResultPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { EmailAuthPage } from "./pages/EmailAuthPage";

const router = createBrowserRouter([{ path: "/", element: <Layout />, children: [
  { index: true, element: <HomePage /> },
  { path: "create", element: <CreatePage /> },
  { path: "result/:id", element: <ResultPage /> },
  { path: "pricing", element: <PricingPage /> },
  { path: "library", element: <LibraryPage /> },
  { path: "account", element: <AccountPage /> },
  { path: "auth/email", element: <EmailAuthPage /> },
  { path: "orders", element: <OrdersPage /> },
  { path: "terms", element: <LegalPage kind="terms" /> },
  { path: "privacy", element: <LegalPage kind="privacy" /> },
  { path: "refund", element: <LegalPage kind="refund" /> },
  { path: "ai-content-policy", element: <LegalPage kind="ai" /> },
  { path: "*", element: <NotFoundPage /> }
]}]);

export function App() { return <RouterProvider router={router} />; }
